import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";

export const depositLimit = z.object({
  dailyLimitDays: z.number(),
  maximumDailyDepositAmount: z.number(),
  minimumDepositAmount: z.number(),
  remainingDailyAmount: z.number(),
  pendingUpdateAt: z.string().nullish(),
  pendingUpdateDailyLimitAmount: z.number().nullish(),
  pendingUpdateDailyLimitDays: z.number().nullish(),
  expiresAt: z.string().nullish(),
  depositAmountAtExpiry: z.number().nullish(),
  currency: z.string(),
  rules: z
    .object({
      allowedDays: z.array(z.number()).optional(),
      maximum: z.number().optional(),
    })
    .optional(),
});

export type DepositLimits = zInfer<typeof depositLimit>;
